import React from 'react';
import PropTypes from 'prop-types';
import ApplictionJumpSection from '../ApplicationJumpSection/ApplicationJumpSection';
import { parseHtml } from '../../../Utility/HelperFunctions';
import { handleKeyDown } from '../../../Utility/ApplicationFormUtility';

const JumptoSection = ({
    handlejumpto = () => { },
    currectStepId,
    getSections,
    buttonSecondaryColor, 
    stepStatus = '',
    submittedSteps = [],
    isMobileOrIpad = false,
    ...props
}) => {
    return (
        <>
        {isMobileOrIpad && <hr className="H5HeadingDivider"></hr>}
            <div className='application-section__jump'>
                <div className='application-section__jump-inner'>
                    <h1
                        className="application-section__title"
                    >
                        Jump to a section
                    </h1>
                    {getSections?.map((val, ind) => {
                        return (<div onClick={(e) => handlejumpto(e, val.sfid)} tabIndex={0} role='button' onKeyDown={(e)=>handleKeyDown(e,()=>handlejumpto(e, val.sfid))}>
                            <ApplictionJumpSection
                                id={val.sfid}
                                label={parseHtml(val.title__c)}
                                buttonSecondaryColor={buttonSecondaryColor}
                                active={val.sfid === currectStepId}
                                stepStatus = { stepStatus }
                                submittedSteps = { submittedSteps }
                                herokuId = { val.heroku_id__c }
                            />
                        </div>
                        )

                    })}
                </div>
            </div>
        </>

    )
}

JumptoSection.propTypes = {
    handlejumpto: PropTypes.func,
    stepStatus: PropTypes.string,
    currectStepId: PropTypes.string,
    buttonSecondaryColor: PropTypes.string,
    submittedSteps: PropTypes.array,
    getSections: PropTypes.object,
    isMobileOrIpad: PropTypes.bool,  
}

export default JumptoSection;